// Color-blind friendly palette with strong contrast
export const mapColors = {
  none: "#71717a", // gray-500
  kellyanOnly: "#60A5FA", // blue-400
  garrettOnly: "#F59E0B", // amber-500
  bothSeparate: "#A78BFA", // violet-400
  bothTogether: "#10B981", // emerald-500
  stroke: "#FFFFFF",
  hover: "#111827",
};

export function getFillColor(countryData) {
  if (countryData) {
    // handle case where neither visited
    if (!countryData.kellyanVisited && !countryData.garrettVisited) {
      return mapColors.none; // Neither visited
    }
    // handle case where only Kellyan visited
    else if (countryData.kellyanVisited && !countryData.garrettVisited) {
      return mapColors.kellyanOnly;
    }
    // handle case where only Garrett visited
    else if (!countryData.kellyanVisited && countryData.garrettVisited) {
      return mapColors.garrettOnly;
    }
    // handle case where both visited separately
    else if (
      countryData.kellyanVisited &&
      countryData.garrettVisited &&
      !countryData.visitedTogether
    ) {
      return mapColors.bothSeparate; // Both visited separately
    }
    // handle case where both visited together
    else if (
      countryData.kellyanVisited &&
      countryData.garrettVisited &&
      countryData.visitedTogether
    ) {
      return mapColors.bothTogether; // Both visited together
    }
  }
  // Default case if no data matches
  return mapColors.none;
}

export function getToolTip(countryName, countryData) {
  if (countryData) {
    // handle case where neither visited
    if (!countryData.kellyanVisited && !countryData.garrettVisited) {
      return `${countryName}: Neither visited`;
    }
    // handle case where only Kellyan visited
    else if (countryData.kellyanVisited && !countryData.garrettVisited) {
      return `${countryName}: Kellyan visited`;
    }
    // handle case where only Garrett visited
    else if (!countryData.kellyanVisited && countryData.garrettVisited) {
      return `${countryName}: Garrett visited`;
    }
    // handle case where both visited separately
    else if (
      countryData.kellyanVisited &&
      countryData.garrettVisited &&
      !countryData.visitedTogether
    ) {
      return `${countryName}: Both visited separately`;
    }
    // handle case where both visited together
    else if (
      countryData.kellyanVisited &&
      countryData.garrettVisited &&
      countryData.visitedTogether
    ) {
      return `${countryName}: Both visited together`;
    }
  }
  // Default case if no data matches
  return `${countryName}: No data`;
}
